/* flow */
import React, { PureComponent } from 'react'
import labels from './labels'
import type { Lang } from './App'
import { doScrolling } from './utils'

type Props = {
  appId: string,
  width: number,
  height: number,
  lang: Lang
}

export default class componentName extends PureComponent<Props> {
  onClick = () => {
    const { appId } = this.props
    doScrolling(`#${appId} .ac-list`, 500)
  }
  render () {
    const { width, height, lang } = this.props
    return (
      <div style={{ width, height }} className='ac-chart__init-box' onClick={this.onClick}>
        <div style={{ top: height * 2 / 5 }} className='init-box__content'>
          <span>{labels[lang].initBoxMsg}</span><br/><br/>
          <i className="arrow alternate circle down icon large"></i>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/InitBox.js